module.exports = __webpack_public_path__ + "static/media/x-circle.80694b69.png";